import { t } from 'i18n';
import React, { useEffect } from 'react';
import { Loading } from 'components/Loading';
import { AccountLayout } from 'components/Layout/AccountLayout';
import { useRouter } from 'next/router';
import { EmptyState } from '@teko/ecommerce/mobile';
import { PageStatus, useNotification } from '../NotificationProvider';
import {
  Flex,
  Card,
  styled,
  Button,
  Title,
  ThemeProps,
} from '@teko/ds-desktop';
import { SizeEnum } from '@teko/types/ds';
import { NotificationList } from '../components/NotificationList';
import { getExternalTypesByPath, onNotificationClick } from '../helper';
import { useTenantConfig } from 'hooks';
import { SHARED_NAV_ITEMS_HREFS } from 'constants/index';
import { useAuth } from '@teko/auth-react';

const NotificationPage: React.FC = () => {
  const {
    notifications,
    checkpoint,
    loading,
    getNotifications,
    markReadNotification,
    status,
    markReadAll,
  } = useNotification();
  const router = useRouter();
  const { epicOmni948 } = useTenantConfig();
  const { user, authService } = useAuth();

  const getTitleByNotiType = () => {
    if (router.query?.type === 'orders') {
      return t('Cập nhật đơn hàng');
    }
    return t('Thông báo của bạn');
  };

  useEffect(() => {
    // redirect users to login page if they access order notification page when not login yet
    if (
      epicOmni948 &&
      router.asPath.includes(SHARED_NAV_ITEMS_HREFS.ORDERS_NOTI) &&
      !user?.userId
    ) {
      authService.login(window.location.href);
    }
  }, [router.asPath, epicOmni948, user?.userId]);

  return (
    <Loading isLoading={loading}>
      <AccountLayout>
        <Flex justify="space-between" marginBottom="s12">
          <Title>{getTitleByNotiType()}</Title>
          <Button
            variant="link"
            color="secondary"
            padding="s0"
            onClick={() => markReadAll(getExternalTypesByPath(router.query))}
          >
            {t('Đánh dấu tất cả đã đọc')}
          </Button>
        </Flex>
        <Card>
          {status === PageStatus.EMPTY && !loading ? (
            <CenteredWrapper>
              <EmptyState text={t('Bạn chưa có thông báo mới')} />
            </CenteredWrapper>
          ) : (
            <>
              <NotificationList
                notifications={notifications}
                onNotificationClick={async (noti) => {
                  await markReadNotification(noti);
                  onNotificationClick(noti, router);
                }}
              />
              {loading && <Message>{t('Đang tải thêm...')}</Message>}
              {!loading && !checkpoint && (
                <Message>{t('Đã hết thông báo!')}</Message>
              )}
              {!loading && !!checkpoint ? (
                <Message>
                  <Button
                    variant="secondary"
                    size={SizeEnum.s}
                    onClick={() => getNotifications(checkpoint)}
                  >
                    {t('Tải thêm')}
                  </Button>
                </Message>
              ) : null}
            </>
          )}
        </Card>
      </AccountLayout>
    </Loading>
  );
};
export default NotificationPage;

const Message = styled.div(
  ({ theme }: ThemeProps) => `
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0.75rem 0;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${theme?.colors.textSecondary};
`,
);

const CenteredWrapper = styled.div`
  padding: 2rem;
  text-align: center;
  margin: 0;
`;
